import { Vector2, Vector3 } from 'three'
import Experience from '../Experience.js'
import Sizes from "./Sizes.js";
export default class Input {
    static instance = null
    static getInstance() {
        return Input.instance || new Input()
    }
    constructor() {
        if (Input._instance) {
            return Input._instance
        }
        Input._instance = this

        this.experience = Experience.getInstance()
        this.canvas = this.experience.renderer.canvas
        this.sizes = Sizes.getInstance()

        this.cursor = new Vector3()
        this.coords_old = new Vector2()
        this.diff = new Vector2()
        this.clientX = 0
        this.clientY = 0

        this.init()
    }

    init() {
        window.addEventListener('mousemove', this.onMouseMoved)
    }

    onMouseMoved = (event) => {
        const x = event.clientX
        const y = event.clientY

        this.clientX = x
        this.clientY = y

        // Calculate cursor position relative to the entire viewport
        this.cursor.x = (x / window.innerWidth) * 2 - 1
        this.cursor.y = -(y / window.innerHeight) * 2 + 1

        this.cursor.x = Math.max(-1, Math.min(1, this.cursor.x))
        this.cursor.y = Math.max(-1, Math.min(1, this.cursor.y))
    }

    update() {
        this.diff.subVectors(this.cursor, this.coords_old)
        this.coords_old.copy(this.cursor)
        if (this.coords_old.x === 0 && this.coords_old.y === 0) this.diff.set(0, 0)
    }

    getCursorPosition() {
        return this.cursor
    }

    getCursorDiff() {
        return this.diff
    }

    calculateCursorDelta(elementRect) {
        const deltaX = elementRect.left / elementRect.width
        const deltaY = -elementRect.top / elementRect.height

        return new Vector2(deltaX, deltaY)
    }

    destroy() {
        window.removeEventListener('mousemove', this.onMouseMoved)
        Input._instance = null
    }
}
